var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map",style:({height: _vm.height})},[_c('el-amap',{staticClass:"amap",attrs:{"vid":"amap","zoom":_vm.zoom,"amap-manager":_vm.amapManager,"center":_vm.center,"events":_vm.events,"plugin":_vm.plugin}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }